(function() {
    $(document).ready(function(){
        <!-- языковой блок-->
        cryptoLangBar();
        
        <!-- система якорь -->
        cryptoAnchor();
    });
    

    
    function cryptoLangBar(){
        $('body').on('click', '[data-langbar]', function(){
            var block = $(this);
            
            if(block.hasClass('active')){
                block.removeClass('active');
                $('[data-langbar_list]').addClass('hide');
            } else {
                block.addClass('active');
                $('[data-langbar_list]').removeClass('hide');
            }
        });
        
        $('body').click(function(event){
            if($(event.target).parents('.crypto-plank__language').html() == null){
                $('[data-langbar]').removeClass('active');
                $('[data-langbar_list]').addClass('hide');
            }
        });
    }
    

    
    function cryptoAnchor(){
        $('body').on('click', '[data-anchor]', function(){
            var block   = $(this),
                id      = block.data('anchor');
            
            if($('[data-anchor_block="' + id + '"]').length > 0) {
                $("html, body").animate({scrollTop: $('[data-anchor_block="' + id + '"]').offset().top}, 500);
            }
        });
    }
    

    particlesJS("particles-js", {
      "particles": {
        "number": {
          "value": 355,
          "density": {
            "enable": true,
            "value_area": 789.1476416322727
          }
        },
        "color": {
          "value": "#ffffff"
        },
        "shape": {
          "type": "circle",
          "stroke": {
            "width": 0,
            "color": "#000000"
          },
          "polygon": {
            "nb_sides": 5
          },
          "image": {
            "src": "img/github.svg",
            "width": 100,
            "height": 100
          }
        },
        "opacity": {
          "value": 0.48927153781200905,
          "random": false,
          "anim": {
            "enable": true,
            "speed": 4,
            "opacity_min": 0,
            "sync": false
          }
        },
        "size": {
          "value": 2,
          "random": true,
          "anim": {
            "enable": true,
            "speed": 10,
            "size_min": 0,
            "sync": false
          }
        },
        "line_linked": {
          "enable": false,
          "distance": 150,
          "color": "#ffffff",
          "opacity": 0.4,
          "width": 1
        },
        "move": {
          "enable": true,
          "speed": 1,
          "direction": "none",
          "random": true,
          "straight": false,
          "out_mode": "out",
          "bounce": false,
          "attract": {
            "enable": false,
            "rotateX": 600,
            "rotateY": 1200
          }
        }
      },
      "interactivity": {
        "detect_on": "canvas",
        "events": {
          "onhover": {
            "enable": true,
            "mode": "bubble"
          },
          "onclick": {
            "enable": true,
            "mode": "push"
          },
          "resize": true
        },
        "modes": {
          "grab": {
            "distance": 400,
            "line_linked": {
              "opacity": 1
            }
          },
          "bubble": {
            "distance": 83.91608391608392,
            "size": 1,
            "duration": 3,
            "opacity": 1,
            "speed": 3
          },
          "repulse": {
            "distance": 200,
            "duration": 0.4
          },
          "push": {
            "particles_nb": 4
          },
          "remove": {
            "particles_nb": 2
          }
        }
      },
      "retina_detect": true
    });
})();